import { AnalyticsBrowser } from '@segment/analytics-next';
const createSegmentClient = () => {
  let _client;
  const initialize = writeKey => {
    _client = AnalyticsBrowser.load({
      writeKey
    });
  };
  const track = (event, properties) => {
    _client?.track(event, properties);
  };
  const identify = userId => {
    _client?.identify(userId);
  };
  return {
    initialize,
    track,
    identify
  };
};
const segmentClient = createSegmentClient();
export default segmentClient;